var _style, _ellipse, _path, _path2, _g, _path3, _path4, _path5, _path6, _defs, _path7, _path8, _rect, _defs2, _path9, _path10, _path11, _rect2, _g2, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _rect8, _path13, _rect9, _rect10, _path14, _path15, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _g3, _rect23, _g4, _line, _g5, _line2, _g6, _rect24, _g7, _g8, _path16, _path17, _g9, _g10, _g11, _g12, _g13, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyLockup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2043.8 855.3",
    style: {
      enableBackground: "new 0 0 2043.8 855.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BBD96A;}\n\t.st1{fill:#B5CC78;}\n\t.st2{fill:none;}\n\t.st3{fill:#91BA45;}\n\t.st4{fill:#D1DBCF;}\n\t.st5{clip-path:url(#SVGID_00000105416706072030074510000016181146913373908366_);}\n\t.st6{fill:#544F73;}\n\t.st7{fill:#FA6663;}\n\t.st8{clip-path:url(#SVGID_00000003786849093256019880000005808977479018340541_);}\n\t.st9{fill:#FCA8A8;}\n\t.st10{fill:#73738C;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#FCC2C2;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.89;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#544F73;stroke-width:1.19;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FFFFFF;stroke-width:1.34;stroke-miterlimit:10;}\n\t.st16{fill:#33364A;}\n\t.st17{fill:#1A1C2E;}\n\t.st18{fill:#1A2B42;}\n\t.st19{fill:#2E334A;}\n\t.st20{fill:none;stroke:#FFFFFF;stroke-width:0.3;stroke-miterlimit:10;}\n\t.st21{fill:#FCADAB;}\n\t.st22{fill:#736357;}\n\t.st23{fill:#292B3B;}\n\t.st24{fill:#45B5B8;}\n\t.st25{fill:#D9AD94;}\n\t.st26{fill:#006938;}\n\t.st27{fill:#00784F;}\n\t.st28{fill:#086945;}\n\t.st29{fill:#637A30;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 599,
    cy: 574.8,
    rx: 599,
    ry: 280.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1859,290.5c-47.6-35.8-87.4-80.4-146.9-82.7c-34.1-1.3-26.8-25.3-59.3-15.1c-37.4-59.1-66.7-35.1-113.5-80.7 c-44.9-43.8-109.3-59.9-170.1-45.8c-32.2,7.5-117.1,9.8-144.5,10.3c-95.2,5.4-112.8,38-168.4,41.6c-67.6,4.4-127.5,44.2-175.3,89.6 c-50.3,47.8-59.3,37.9-93.4,98.3c-17.3,30.7-16.6,21.2-29.3,54.1c-1.6,4.2-2,7.2-6.5,8.9c-2.7,1-5.9,1.4-8.7,2.2 c-8.3,2.3-16.3,5.3-24.1,9c-14.4,6.8-27.8,15.5-40,25.7c-49.5,41.5-74.2,101.3-90.2,162.4c4.9,3,10,5.8,15.1,8.6 c30.6-7.4,63.5-6,94.9-3.4c48.8,4,97.5,8.2,146.4,10.8c98.1,5.2,196.5,7.3,294.8,9.4c97.2,2.1,194.7,2.8,291.8-4.3 c95.3-7,190.5-21.7,281.9-50.4c81-25.4,180.7,20.5,256.4-17.6c3-6.3,25.4-21.3,29.9-26.8C1983.8,418.1,1903.1,323.7,1859,290.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.2,326.9l47.4,163c0,0,29-20.4,172.4-39.2l59.7-41.2l-15.6-49.9l-33.6-74l-112.6-36.2L559.2,326.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.026 249.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574.7,118c0.9-21.3,3-42.8,9.9-63c4-11.6,9.7-22.9,17.8-32.1c7-8,19.5-18.7,31.1-16.5 c19.8,3.7,19.2,33.8,18.9,48.6c-1,60.7-17.5,117.3-41.8,170.2c-1,2.1-4.6,10.9-5.6,13.1l-26.5,6C576.3,206.9,573.2,155.3,574.7,118 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M609,208.1c5.8-26.3,22.5-67.1,36.5-90.2c14.2-23.4,30.8-46,54.7-60.2c3.7-2.2,8.7-3.4,12.3-0.9 c10,6.8,2.6,28.4,0.1,37.4c-3.4,12.3-9.1,23.9-14.8,35.3c-17,34.1-37.7,66.2-61.8,95.7l-26.1,26.9 C605.6,233.3,604.7,227.6,609,208.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M505.4,96.3c0.3-4.5,0.9-9.2,3.2-13.1c6.7-11.8,17-5.4,23.2,2.5c16.6,21.2,28.3,45.3,38.5,70.1 c11.4,27.7,19.7,56.6,24.7,86.1l-19.7,24.2c-19.5-24.5-37.8-50.2-51-78.5C511.1,159.3,503,127.7,505.4,96.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M669.8,169.6c7.7-7.7,19.1-19.5,28.1-25.6c8.6-5.8,20.5-14.7,31-16.1c9.1-1.2,13.7,6.1,12.9,14.4 c-0.9,9.5-6.1,18.2-12.2,25.3c-21.9,25.8-56.8,40.5-87.1,54l-5.7-2C645,199.2,654.1,185.2,669.8,169.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M574,167.5c8,18.1,13.1,37.5,16.9,56.8c0.1,0.7,1.2,0.4,1-0.3c-3.8-19.4-9-38.9-17-57.1 C574.7,166.3,573.8,166.8,574,167.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M604.5,219.8c5.2-28.5,15.4-56,29.2-81.4c3.9-7.2,8-14.3,12.5-21.2c0.4-0.6-0.5-1.1-0.9-0.5 c-15.6,24.4-28.1,50.8-36.1,78.6c-2.3,8-4.2,16.1-5.7,24.2C603.3,220.2,604.4,220.5,604.5,219.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633.2,219.8c19.4-19.2,36.5-40.6,51-63.7c0.4-0.6-0.5-1.1-0.9-0.5c-14.6,22.9-31.4,44.5-50.8,63.5 c-0.2,0.2-0.2,0.6,0,0.8C632.7,220,633,220,633.2,219.8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1128.2,666.3c111,1.7,678.3,44.5,845.6-43.3c157.1-82.5,10.9-235.5-86.7-251.7s-358.8,32.1-426.3,46.7 s-159.5,9.6-150.2-17.9c9.3-27.5-5.8-58.8-122.9-48.8s-397.2,63.4-539.9,96.6C504.9,481,451.8,603.6,503.6,635 C555.5,666.3,905.5,663,1128.2,666.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1982.1,618c51.9-34.2,71.2-57.2,57.4-113.5c-4.5-18.4-25.2-24.9-42.1-38.1c-40-1.7-85.6,0-125.5,3.4 c-29,2.5-57.8,6.3-86.5,11.5c-19.2,3.5-44.5,7.6-46.1,33.4c-0.8,12,3,24.1,0.9,36.1c-2,12.1-10.8,18.8-21.5,21.1 c-9.6,2.1-19.5,1.8-29.1,3.7c-10.5,2.1-18.1,7.6-25.6,15.7c-4.5,4.9-8.9,9.8-14.3,13.6c-5.4,3.7-11.3,6.5-17.6,8.5 c-12.1,4-24.8,5.4-37.3,7.4c-27.6,4.4-55,10-82.1,16.8c-42,10.6-83.4,21.8-123.7,38.3C1555.1,681.1,1884.8,682.1,1982.1,618"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M528.7,532.1c43.1,3.7,86.4,5.1,129.6,4.1c43.2-0.8,86.4-4,129.3-9.6c17.4-2.3,35.2-5.6,51.3-16.6 c8.3-5.6,15.4-13.6,22.4-22.4c7.9-10,15.7-18.4,25.7-22.6c17.4-7.4,35.9-6.1,53.4-12.7c18.3-6.9,26-23.6,26.9-27.4 c5.3-22.5-3.3-48.1-70.1-39.9c-66.8,8.2-226.5,51.9-307.9,79c-36.2,12-62.3,38.5-77.5,66.5C517.4,531.1,523,531.6,528.7,532.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M947.6,387.2c0,0,286.9,1,371.1,42.7c84.1,41.7,274.4,61.4,353.8,40.4s316.6-47.3,367,34.2 c0,0-8.7-35.5-31.4-58.9c-26.2-27-255.3-42.1-367.2-26.4c-111.9,15.8-173.4,28.1-284.2-4.1c-110.8-32.2-369.8-39.9-422.6-30.9 L947.6,387.2L947.6,387.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1111.5,
    y: 123.7,
    transform: "matrix(0.9047 -0.4261 0.4261 0.9047 -1.266 595.1036)",
    width: 435.9,
    height: 353.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018196639991524157680000015297456683273189279_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.809 47.661)",
    style: {
      clipPath: "url(#SVGID_00000018196639991524157680000015297456683273189279_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M814.9,174.4c-12.6-1.3-25-2.5-37.6-3.4c-6.3-0.5-12.6-0.9-18.9-1.1c-3.2-0.1-6.4-0.2-9.6-0.2 c-3.2,0-6.5,0-10,0.3c-0.9,0.1-1.8,0.2-2.8,0.4c-0.5,0.1-1.1,0.2-1.6,0.3c-0.7,0.2-1.4,0.4-2.1,0.7c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.1,0.1-0.3,0.2-0.4,0.2l-0.2,0.1l-0.2,0.2c-0.2,0.1-0.3,0.2-0.5,0.4c-0.4,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.1,0.2-0.2,0.3-0.3,0.5l-0.1,0.2l0,0.1l-0.1,0.2l-0.1,0.4l-0.1,0.2l0,0.1l-0.1,0.3c-0.1,0.4-0.2,0.6-0.2,1 c-0.2,0.9-0.3,1.9-0.4,2.9c-0.2,1.7-0.3,3.3-0.4,5c-0.1,1.6-0.2,3.2-0.2,4.8c-0.2,6.3-0.3,12.6-0.3,18.9c0,12.5,0.1,25.1,0.3,37.6 l7.7,0.1c0.5-12.4,1.2-24.9,2-37.3c0.4-6.2,0.9-12.4,1.5-18.5c0.1-1.5,0.3-3,0.5-4.5c0.2-1.3,0.3-2.7,0.5-3.9c0.3,0,0.6,0,1,0 c2.7-0.1,5.7,0.1,8.7,0.3c3,0.2,6,0.5,9.1,0.8c6.1,0.6,12.2,1.4,18.4,2.3c12.3,1.7,24.6,3.6,36.7,5.7L814.9,174.4L814.9,174.4z  M739.2,179.9c0,0,0,0.1,0,0.1v0C739.2,180,739.2,180,739.2,179.9L739.2,179.9L739.2,179.9L739.2,179.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M740.9,260.2H736l-0.1,37.4c0,1.3,1.1,2.4,2.4,2.4h0.1c1.3,0,2.4-1.1,2.4-2.4c0,0,0,0,0,0L740.9,260.2 L740.9,260.2z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1299.5,
    y: 293.9,
    transform: "matrix(0.2127 -0.9771 0.9771 0.2127 725.4247 1514.0126)",
    className: "st7",
    width: 5.5,
    height: 25.8
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000162333284782966583070000015334069783376196270_",
    x: 1111.5,
    y: 123.7,
    transform: "matrix(0.9047 -0.4261 0.4261 0.9047 -1.266 595.1036)",
    width: 435.9,
    height: 353.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000177463756950362744090000010393905160626087046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000162333284782966583070000015334069783376196270_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.809 47.661)",
    style: {
      clipPath: "url(#SVGID_00000177463756950362744090000010393905160626087046_)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M724.1,231.3c0,0,5.7,22.2-13.4,31.9c0,0-4.8,3,2.1,2.2c6.9-0.8,16.9-5.8,19.2-10.1c0,0,3.8,6.6,3.9,4.3 c0.1-2.3,0.9-28.8,0.9-28.8L724.1,231.3L724.1,231.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M895,205l-62.7-13.6c-1.6-0.3-3.1,0.7-3.5,2.2c0,0.1,0,0.2-0.1,0.3l-0.5,4.6l-3,29.9 c-0.1,1.5,0.8,2.8,2.3,3.1l54.9,11.9c1.4,0.3,2.9-0.5,3.4-1.9l9.7-28.5l1.5-4.4c0.5-1.5-0.3-3.2-1.8-3.7 C895.2,205.1,895.1,205.1,895,205 M835.8,224c-0.3,1.3-1.5,2.1-2.8,1.8c-1.3-0.3-2.1-1.5-1.8-2.8l3.7-16.9 c0.3-1.3,1.6-2.1,2.9-1.8c0.6,0.1,1.1,0.5,1.5,1c0.3,0.5,0.4,1.2,0.3,1.8L835.8,224L835.8,224z M845.3,226.1 c-0.2,1.3-1.4,2.2-2.8,2c-1.3-0.2-2.2-1.4-2-2.8c0-0.1,0-0.2,0.1-0.2l3.7-16.9c0.3-1.3,1.6-2.1,2.9-1.8c0,0,0,0,0,0 c0.6,0.1,1.2,0.5,1.5,1.1c0.4,0.5,0.5,1.2,0.3,1.8L845.3,226.1L845.3,226.1z M854.7,228.1c-0.3,1.3-1.5,2.1-2.8,1.8 c-1.3-0.3-2.1-1.5-1.8-2.8l0,0l3.7-16.9c0.3-1.3,1.5-2.1,2.8-1.8c0,0,0,0,0,0c0.6,0.1,1.2,0.5,1.5,1.1c0.3,0.5,0.4,1.2,0.3,1.8 L854.7,228.1L854.7,228.1z M864.1,230.2c-0.3,1.3-1.5,2.1-2.8,1.9s-2.1-1.5-1.9-2.8c0,0,0-0.1,0-0.1l3.7-16.9 c0.3-1.3,1.6-2.1,2.9-1.8c0.6,0.1,1.1,0.5,1.5,1c0.3,0.5,0.4,1.2,0.3,1.8L864.1,230.2L864.1,230.2z M873.6,232.3 c-0.2,1.3-1.4,2.2-2.8,2c-1.3-0.2-2.2-1.4-2-2.8c0-0.1,0-0.2,0.1-0.2l3.7-16.9c0.3-1.3,1.6-2.1,2.9-1.8c0,0,0,0,0,0 c0.6,0.1,1.2,0.5,1.5,1.1c0.3,0.5,0.5,1.2,0.3,1.8L873.6,232.3L873.6,232.3z M883,234.3c-0.3,1.3-1.5,2.1-2.8,1.9 s-2.1-1.5-1.9-2.8c0,0,0-0.1,0-0.1l3.7-16.9c0.3-1.3,1.5-2.1,2.8-1.8c0,0,0,0,0,0c0.6,0.1,1.2,0.5,1.5,1.1 c0.3,0.5,0.4,1.2,0.3,1.8L883,234.3z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1471.1,253.4l-2.6,7.5l-67.3-14.6l0.8-7.9L1471.1,253.4z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.5,
    y: 123.7,
    transform: "matrix(0.9047 -0.4261 0.4261 0.9047 -1.266 595.1036)",
    className: "st2",
    width: 435.9,
    height: 353.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.809 47.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M898.5,211.7l-72-15.7c-1.2-0.3-2-1.4-1.7-2.6c0,0,0,0,0,0l0.4-1.7c0.7-3,3.7-5,6.7-4.3l65.4,14.2 c3,0.7,5,3.7,4.3,6.7l-0.4,1.7C900.9,211.2,899.7,212,898.5,211.7C898.5,211.7,898.5,211.7,898.5,211.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M892.1,249.2L822.3,234c-0.9-0.2-1.5-1.1-1.3-2c0.2-0.9,1.1-1.5,2-1.3l69.7,15.2c0.9,0.2,1.5,1.1,1.3,2 C893.9,248.8,893,249.4,892.1,249.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M723.8,115.9c0,0-12.8-10.6-16.9-9.7c-4.1,0.9,7,12.3,16.9,13.8L723.8,115.9L723.8,115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M719.2,110.1c-0.7,2.7-1.4,5.3-2,8c43,10,62.2,2,89.8-31.6c4.2-5.2,2.5-7.5-2.7-9.3l0,0 c-5.2-1.7-6.2-0.3-9.8,4.3C771.2,111.7,756.5,115.3,719.2,110.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M681.4,170.1c0,0,28.8,73.8,81.9,100.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M683.2,166.5l10.4-19.9c1.3-2.5,0.7-5.7-1.6-7.5l-2.7-2.1c-4.6-3.7-5.3-10.4-1.7-15c0.8-1,1.7-1.8,2.8-2.4 c3.7-2.3,8.2-2.9,12.4-1.8l20.2,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M706.5,118.9c0.4-1.8,2.2-3,4-2.6c1.8,0.4,3,2.2,2.6,4c-0.4,1.8-2.2,3-4,2.6 C707.3,122.6,706.1,120.8,706.5,118.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M710.9,119.9c0.4-1.8,2.2-3,4-2.6c1.8,0.4,3,2.2,2.6,4c-0.4,1.8-2.2,3-4,2.6 C711.7,123.5,710.5,121.7,710.9,119.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M715.4,120.9c0.4-1.8,2.2-3,4-2.6c1.8,0.4,3,2.2,2.6,4c-0.4,1.8-2.2,3-4,2.6 C716.1,124.5,715,122.7,715.4,120.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M719.8,121.8c0.4-1.8,2.2-3,4-2.6c1.8,0.4,3,2.2,2.6,4c-0.4,1.8-2.2,3-4,2.6 C720.5,125.5,719.4,123.6,719.8,121.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M724.2,122.8c0.4-1.8,2.2-3,4-2.6c1.8,0.4,3,2.2,2.6,4c-0.4,1.8-2.2,3-4,2.6 C725,126.4,723.8,124.6,724.2,122.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M815.6,206.3l-70,86 M666.5,199.8c0,0,31,17.7,37.1,53.8c6.1,36.1,37.3,43.9,37.3,43.9"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1167,
    y: 282.2,
    transform: "matrix(0.3733 -0.9277 0.9277 0.3733 489.2413 1289.6207)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1184.1,
    y: 295,
    transform: "matrix(0.7872 -0.6168 0.6168 0.7872 76.6287 813.0104)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1192.4,
    y: 314.6,
    transform: "matrix(0.9901 -0.1406 0.1406 0.9901 -32.1295 175.2487)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1221.5,
    y: 304.1,
    transform: "matrix(0.3735 -0.9276 0.9276 0.3735 453.6761 1344.2996)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1208.7,
    y: 321.2,
    transform: "matrix(0.7864 -0.6177 0.6177 0.7864 40.0364 822.4361)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1193.6,393.5l1-0.1l-9-63.7l-1,0.1L1193.6,393.5z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1136.3,
    y: 358.5,
    transform: "matrix(0.3733 -0.9277 0.9277 0.3733 399.17 1308.9594)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1126.4,366.5l50.7-39.7l-0.6-0.8l-50.6,39.7L1126.4,366.5z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1110.9,
    y: 326.1,
    transform: "matrix(0.9901 -0.1406 0.1406 0.9901 -34.5633 163.9114)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1145.2,
    y: 273.4,
    transform: "matrix(0.3735 -0.9276 0.9276 0.3735 434.3509 1254.2225)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1177.9,314.1l0.8-0.6l-39.7-50.6l-0.8,0.6L1177.9,314.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1182.1,312.1l1-0.1l-9-63.7l-1,0.1L1182.1,312.1z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1409.6,
    y: 297.5,
    transform: "matrix(0.9978 -6.698349e-02 6.698349e-02 0.9978 -18.916 95.1935)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1398.9,
    y: 333.4,
    transform: "matrix(0.4403 -0.8979 0.8979 0.4403 501.2609 1471.7747)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1414.9,
    y: 347.2,
    transform: "matrix(0.8301 -0.5576 0.5576 0.8301 51.9352 865.9333)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1421.8,
    y: 367.5,
    transform: "matrix(0.9977 -6.766703e-02 6.766703e-02 0.9977 -21.5705 99.2253)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1449.4,
    y: 356.8,
    transform: "matrix(0.44 -0.898 0.898 0.44 462.6882 1519.7917)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1435.3,
    y: 372.7,
    transform: "matrix(0.8299 -0.5579 0.5579 0.8299 18.3723 869.944)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1415.1,
    y: 379.7,
    transform: "matrix(0.9978 -6.698349e-02 6.698349e-02 0.9978 -24.4107 95.7497)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1362.7,
    y: 407.3,
    transform: "matrix(0.4403 -0.8979 0.8979 0.4403 414.6276 1480.6067)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1346.6,
    y: 393.1,
    transform: "matrix(0.8301 -0.5576 0.5576 0.8301 14.7518 835.6411)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1339.6,
    y: 373.1,
    transform: "matrix(0.9977 -6.766703e-02 6.766703e-02 0.9977 -22.1366 93.682)",
    className: "st6",
    width: 64.3,
    height: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1375.5,
    y: 320.5,
    transform: "matrix(0.44 -0.898 0.898 0.44 453.8369 1433.1382)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1389.4,
    y: 304.4,
    transform: "matrix(0.8299 -0.5579 0.5579 0.8299 48.6749 832.7208)",
    className: "st6",
    width: 1,
    height: 64.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(622.143 243.403)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M760.1,124.5c17.2,3.8,29.8,5.6,30.1,5.6c1.1,0.2,2.2-0.6,2.4-1.8c0.2-1.1-0.6-2.2-1.8-2.4 c-0.5-0.1-55.7-8.1-92.7-25c-1-0.5-2.3,0-2.8,1c0,0,0,0,0,0c-0.5,1.1,0,2.3,1,2.8C716.1,113.9,741,120.4,760.1,124.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M486,61c9.1-41.8,50.4-68.3,92.2-59.2s68.3,50.4,59.2,92.2s-50.4,68.3-92.2,59.2c0,0,0,0,0,0 C503.4,144,476.9,102.8,486,61 M494.1,62.8c-8.1,37.3,15.5,74.1,52.8,82.2s74.1-15.5,82.2-52.8c8.1-37.3-15.5-74.1-52.8-82.2 c0,0,0,0,0,0C539.1,1.9,502.3,25.5,494.1,62.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M716,113.7c9.1-41.8,50.4-68.3,92.2-59.2s68.3,50.4,59.2,92.2s-50.4,68.3-92.2,59.2c0,0,0,0,0,0 C733.5,196.7,707,155.5,716,113.7 M724.2,115.5c-8.1,37.3,15.5,74.1,52.8,82.2c37.3,8.1,74.1-15.5,82.2-52.8 c8.1-37.3-15.5-74.1-52.8-82.2c0,0,0,0,0,0C769.2,54.6,732.4,78.2,724.2,115.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M706.2,102.9c2-9.2-3.8-18.2-13-20.2s-18.2,3.8-20.2,13s3.8,18.2,13,20.2c0,0,0,0,0,0 C695.2,117.8,704.2,112,706.2,102.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M700.9,101.7c-3.3-3.3-8.6-3.3-11.8,0c-3.3,3.3-3.3,8.6,0,11.8c3.3,3.3,8.6,3.3,11.8,0 C704.2,110.3,704.2,105,700.9,101.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M671.7,111.9c-3.2-4.8-4.4-10.7-3.2-16.3c1.2-6,4.9-11.3,10.2-14.5c4.5-2.8,10-3.6,15.1-2.2 c12.3,3.6,30.5,10.3,48,16.9c19,7.1,38.6,14.5,51.8,18.1c7.1,2,11.4,8.5,10,15.3c-1.5,7-8.3,11.5-15.3,10.1 c-13.3-2.5-33.8-6.1-53.5-9.6c-18.3-3.2-37.2-6.5-49.7-8.9c-0.1,0-0.2,0-0.3-0.1C679.5,119.7,674.8,116.5,671.7,111.9 M793.2,115.5 c-13.2-3.7-32.9-11-51.9-18.1c-17.5-6.6-35.7-13.4-47.9-16.9c-4.7-1.3-9.7-0.6-13.8,2c-4.9,3-8.3,7.8-9.4,13.4 c-1.1,5.2,0,10.6,3,15c2.8,4.2,7.2,7.2,12.1,8.2c0.1,0,0.2,0,0.3,0.1c12.4,2.4,31.3,5.7,49.6,8.9c19.8,3.5,40.2,7.1,53.5,9.6 c6.1,1.2,12-2.7,13.3-8.8C803.2,123,799.4,117.3,793.2,115.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M800,128.2c0-4.6-3.7-8.2-8.2-8.2c-4.6,0-8.2,3.7-8.2,8.2c0,4.6,3.7,8.2,8.2,8.2 C796.3,136.5,800,132.8,800,128.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M570.5,79.4c1.1-4.9-2-9.6-6.9-10.7c-4.9-1.1-9.6,2-10.7,6.9c-1.1,4.9,2,9.6,6.9,10.7 C564.6,87.3,569.4,84.3,570.5,79.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M743.8,3.6c0.4-1.7,2.1-2.9,3.8-2.6l35.2,6.1c2.1,0.4,3.4,2.5,2.9,4.5l-1.3,5.8c-0.5,2.1-2.6,3.5-4.7,3 c-0.2,0-0.4-0.1-0.6-0.2L745.8,7.5C744.3,6.9,743.4,5.2,743.8,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M703.4,139l4.4-2l-17.4-37.8c-0.6-1.2-2-1.7-3.2-1.2l-0.1,0c-1.2,0.6-1.7,2-1.2,3.2L703.4,139L703.4,139z"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1321.7,
    y: 366.3,
    transform: "matrix(0.2127 -0.9771 0.9771 0.2127 672.2526 1592.7035)",
    className: "st7",
    width: 5.5,
    height: 25.8
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(695.908 93.21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M681.6,13.1c5.7-9.2,19.4-15.5,30.2-12.2s15,16.5,11.9,26.8c-3.1,10.3-19.6,21.7-36.2,18 C676.4,43.2,674.3,24.7,681.6,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M488,228c0,0,46.9-55.9,51.2-64.8c4.3-8.9,25.9-52.3,25.9-52.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M491.6,228.5c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1C490.2,225.4,491.6,226.7,491.6,228.5"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 1412.5,
    y1: 369.5,
    x2: 1366.7,
    y2: 280.4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(871.993 82.415)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M524.4,150.7c-9.5-4.7-11-3.4-20.6-8c-21.7,60.5-21.2,121.1-9.1,183.4l7.6-1.4 C490.8,263.4,497.6,209,524.4,150.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M490.5,318.5c0,0,11,20.1-5.2,34.2c0,0-4,4.1,2.6,1.6s14.9-9.8,16.2-14.5c0,0,5.3,5.5,4.8,3.2 c-0.4-2.3-6.2-28.2-6.2-28.2L490.5,318.5L490.5,318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M586.7,18c0,0,4-16.1,7.8-17.8c3.8-1.7,1.7,14-5.4,21.1L586.7,18L586.7,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M586.5,16.9c2.7,1,5.1,1.9,7.7,3c-19.3,42-38,50.3-81,35.6c-6.6-2.2-6.2-4.4-2.8-9.1c-0.9-1-0.9-1,0,0 c3.5-4.6,4.9-4,10.5-2C557.3,58,567.6,49.6,586.5,16.9"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 1466.9,
    y1: 294.1,
    x2: 1412.9,
    y2: 369.3
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(744.399 196.633)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M671.8,173.7c2.7,0,4.9,2.2,4.9,4.9c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9 C666.9,175.9,669.1,173.7,671.8,173.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M486.9,1.6l-2.6,12c-0.2,1.1,0.5,2.2,1.6,2.5c0,0,0,0,0,0l3.5,0.8l3.5-16L489.3,0 C488.2-0.2,487.1,0.5,486.9,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M501.4,2.7l-8.6-1.9l-3.5,16l8.6,1.9c4.4,1,8.8-1.9,9.8-6.3C508.7,8,505.8,3.6,501.4,2.7"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1249.7,
    y: 206.2,
    transform: "matrix(0.2125 -0.9772 0.9772 0.2125 779.6513 1389.5448)",
    className: "st11",
    width: 4.5,
    height: 9.6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(817.384 83.584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M560.1,0.1c3.1,0.4,6.5,3.3,6.9,6.6c0.4,3.3-2.5,6-5.7,6.4c-3.1,0.4-8.4-3.9-8.8-7.1 C552.1,2.6,556.2-0.5,560.1,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M558.8,17.1c2.8-4.6,9.5-7.9,14.7-6.3c5.2,1.6,7.1,8.2,5.6,13.4c-1.6,5.2-11.7,10.6-16.9,9 C556.9,31.5,555.2,23,558.8,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M569.7,22.7c-5.9,7.7-16.1,9.9-20.8,6.3c-4.7-3.6-2.2-11.6,3.7-19.4c5.9-7.7,12.8-8.8,17.5-5.2 S575.6,15,569.7,22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M574.6,18.6c0,0,2.2-6.2-0.4-11c-2.5-4.7-10.2-10.2-17.1-4.5c0,0-4.5,4.4,1.3,9.4s6.9,0.9,7.9,6.1 c1.1,5.2,5.4,4.7,5.5,5.8L574.6,18.6L574.6,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M509.3,173.9c4.4,3.9,9,6.8,12.2,11.6c3.1,4.7,4.6,9.8,6.1,15.2c1.7,5.8,3,11.7,4.8,17.6 c1.2,4,2.1,7.9,4.3,11.8c7.3,12.6,21.2,18.8,35.5,16.4c6.6-1.1,12.5-4.4,19.3-3.8c8.4,0.7,14.4,6.4,22.2,9c7.1,2.4,13.6,0.9,20-2.8 c-64-50.4-35.9-68.4-43-134.5c-1.6-14.6-8.3-49.6-12.7-60.7c-3.9-9.6-5.4-11.2-9.7-14.6c-6-4.7-7.7-1.4-12.7-0.2 c-0.1,0-0.1,0-0.2,0.1c-4.9,7.2-5.6,10-7,20.5c-1.4,10.4-5.2,5.9,2,23.6c2.6,6.3,11.6,31.3,1.4,42.2c-3.3,3.5-44.1,1.5-53.8,2.6 c-4.7,0.5-10,3.8-13.9,6.6c1,3.3,1.7,6.6,3,9.7C492,155.9,499.8,165.6,509.3,173.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M524.8,146c13.8,29.7,18.6,55.7,41.5,51.9s20.3,13.1,37.4,22.6c0.4,0.2,0.8,0.4,1.2,0.6 c-25-32.1-8.4-54.3-14.1-106.7c-1.6-14.6-8.3-49.6-12.7-60.7c-3.8-9.6-5.4-11.2-9.7-14.6c-6-4.7-7.7-1.4-12.7-0.2 c-0.1,0-0.1,0-0.2,0.1c-4.9,7.2-5.6,10-7,20.5c-1.4,10.4-5.2,5.9,2,23.6c2.6,6.3,11.6,31.3,1.4,42.2c-2.5,2.6-25.9,2.2-41.5,2.2 C515.2,130.7,520.3,136.4,524.8,146"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M603.6,220.5c-17.1-9.5-14.6-26.3-37.4-22.6c-22.8,3.7-27.6-22.2-41.5-51.9c-4.5-9.6-9.6-15.3-14.4-18.6 c-5.3,0-9.8,0.1-12.2,0.4c-4.7,0.5-10,3.8-13.9,6.6c1,3.3,1.7,6.6,3,9.7c4.8,11.9,12.6,21.5,22.1,29.8c4.4,3.9,9,6.8,12.2,11.6 c3.1,4.7,4.6,9.8,6.1,15.2c1.7,5.8,3,11.7,4.8,17.6c1.2,4,2.1,7.9,4.3,11.8c7.3,12.6,21.2,18.8,35.5,16.4 c6.5-1.1,12.5-4.4,19.3-3.8c8.4,0.7,14.4,6.4,22.2,9c7.1,2.4,13.6,0.9,20-2.8c-13.2-10.4-22.5-19.4-28.9-27.7 C604.3,220.9,603.9,220.7,603.6,220.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M566.4,23.3L556.3,22c-0.2,1.4-1.6,14.6-1.3,19.7c0.3,1.5,2.8,2.3,5.6,1.7c2.5-0.5,4.3-2,4.4-3.4l0,0 C564.9,37,565.8,28.2,566.4,23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M571.3,27.5c-1.4,1.8-4.9,2.7-6.2,1.7c-1.3-1-0.5-2.7,0.9-4.5c1.4-1.8,3.7-2.7,5-1.7 C572.3,24.1,572.7,25.7,571.3,27.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.458 70.103)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M728.7,253.8c0-0.2,0-0.5,0-0.7c-0.3-2-2.2-3.4-4.2-3c0,0,0,0,0,0l-26,4.2c-2,0.3-3.4,2.2-3,4.2 s2.2,3.4,4.2,3l26-4.2C727.3,256.9,728.6,255.5,728.7,253.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M721.2,249.7c0,0,7.8-5.7,8.9-3.7c1.1,2,14.6,31.8,13.3,32.5c-4.5,2.6-19.2-20.2-19.7-22.9 C723.2,253.1,720.1,250.5,721.2,249.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M513,358.1c0.2,0.2,0.4,0.3,0.6,0.4c1.8,0.9,4,0.2,4.9-1.6l12.1-23.4c0.9-1.8,0.2-4-1.6-4.9 c-1.8-0.9-3.9-0.2-4.9,1.5l-12.1,23.4C511.3,355.1,511.7,357,513,358.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M515.6,340.3c2.9,2.8,5.9,5.5,9.1,7.9c34.1-59.9,59.8-141.4,95.7-193.7c-8.8-5.6-17.7-11-26.6-16.5 C557.7,201.2,563,268.5,515.6,340.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M520.5,355.3c0,0,0.4,9.7-1.8,9.5c-2.3-0.2-34.6-5.4-34.5-6.9c0.3-5.2,27.5-4.8,29.9-3.8 S520.4,353.9,520.5,355.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M596.1,158.7c0,0-5.7,29.7,3.2,70s23.9,49.6,78.9,37l38.5-6.7l-2.3-8.2c0,0-77.8,10.7-87.4-6.6 s-7.8-59.3,1.1-92.3C628.3,152,602.3,147,596.1,158.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M519.5,81.9c0,0-18.3-4.8-22.1-2c-3.8,2.8,13.1,9.4,24,6.2L519.5,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M519.2,79.7c-0.9,3-1.7,5.9-2.3,8.8c47.4,10.8,69,10.7,100.4-28.2c4.8-5.9,2.7-8.1-2.6-10.8 c0.4-1.3,0.4-1.3,0,0c-5.3-2.6-7-1.1-11.2,4.2C576.4,88,560.6,84.7,519.2,79.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M626.9,24.9c-6.5,9-18.1,11.7-23.5,7.7c-5.5-4-2.8-13.2,3.7-22.1c6.5-9,14.3-10.3,19.8-6.3 C632.3,8.1,633.5,15.9,626.9,24.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M628.7,30.9c-1.5,2.1-5.5,3.3-7,2.2c-1.5-1.1-0.7-3.1,0.9-5.2s4.2-3.1,5.7-2S630.3,28.8,628.7,30.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M632.4,20.1c0,0,2.3-7.1-0.7-12.5s-11.9-11.3-19.6-4.7c0,0-5,5.2,1.8,10.7s7.9,0.8,9.2,6.7s6.2,5.2,6.4,6.4 L632.4,20.1L632.4,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M584.2,157.7c8.6,1.9,15.9,0.2,24-2.8c6.3-2.3,13.8-2.4,20.2-3.6c9.5-25.9,11.8-70.4,4.7-89.5 c-6.3-16.8-6.8-14.3-9.8-16.3c-4.2-2.9-9.7-3.1-14-0.5c-0.1,0.1-0.2,0.1-0.2,0.2c-5,3.3-6.9,12.1-9.3,21.2s-2.2,11.8-5,26.7 C592.4,111.7,586.6,144,584.2,157.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M623.2,25.6l-11.6-1.2c-0.2,1.6-1.5,16.7-0.9,22.4c0.4,1.8,3.3,2.6,6.5,1.8c2.8-0.7,4.9-2.4,5-4l0,0 C621.8,41.2,622.6,31.1,623.2,25.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M676.1,143.5c0,0-6.9,18.6-4.3,22.9s11.1-12.7,8.9-24.5L676.1,143.5L676.1,143.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M673.8,147.9c3.1,0.7,5.8,1.5,9.2,2.3c8.7-62-5-74.4-59.7-98c-8.4-3.6-14.9,10.7-0.4,15.3 C674.2,83.7,674.9,93.1,673.8,147.9"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1514.9,581.1l0.2,31.7h34.9v-31.7H1514.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1652.7,582.3l0.2,30.6h34.9v-30.6H1652.7z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.906 323.348)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M635.5,19.6C639.1,2.8,648,0,654.2,0.2c0.4-0.1,0.8-0.2,1.3-0.2c5-0.3,9.3,3.4,9.7,8.4c0,0.1,0,0.2,0,0.3 l4.9,143.1c0.1,2.3-1.6,4.2-3.9,4.3c-0.7,0.1-1.5-0.1-2.1-0.4c-5.2-1.4-9.2-5.5-10.3-10.8C647.5,117.5,630.9,41.4,635.5,19.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M625.5,38.3c13.1-11,11.5-20.2,8.4-25.6c-0.1-0.4-0.3-0.8-0.4-1.2c-2-4.6-7.4-6.6-12-4.6 c-0.1,0-0.2,0.1-0.3,0.1L492.4,69.5c-2,1-2.9,3.4-2,5.5c0.3,0.7,0.8,1.3,1.4,1.7c3.7,3.9,9.2,5.5,14.3,4.1 C533.3,73.5,608.4,52.6,625.5,38.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M651.6,146.2c2.5-5,5.3-7.5,10-7.5c5,0,9.1,4.1,9.1,9.1c0,0.1,0,0.2,0,0.3l-4.9,143.1c-0.1,2.3-2,4.1-4.3,4 c-2.2-0.1-4-1.8-4-4l-0.2-6.2C649.2,187,644.1,164.4,651.6,146.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M492.7,69.4c-5.2,2-8,4.6-8.5,9.2c-0.5,5,3.1,9.4,8.1,9.9c0.1,0,0.2,0,0.3,0L635.5,98 c2.3,0.2,4.3-1.6,4.5-3.9c0.1-2.2-1.4-4.1-3.6-4.4l-6.1-0.8C533.6,71.1,511.5,63.8,492.7,69.4"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.159 323.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M632.9,13.2c4,39.3,10.6,78.2,19.9,116.6c0,0-13.7,22.9,3.6,120.2l20.1-2.7c0,0,3.4-109.6,3.2-121.9 C679.4,113.1,670,1,670,1L632.9,13.2L632.9,13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M639.2,34.8c0,0-17.5,15.7-87.5,36.4c0,0,6.1-3.6,63.4,11.6l-9.6,16.5c0,0-106.7-2.5-115.4-8.5 c-5.9-4.1-10.2-15.4,1.7-25.3C503.6,55.5,626.2,0,626.2,0l14.9,15.7L639.2,34.8L639.2,34.8z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.587 95.385)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M556.2,34.5C536.8,30.4,509,48.8,512,70.2c0.3,2,0.8,4,0.5,6c-0.5,3.1-3,5.6-5.5,7.5 c-5.7,4.4-12.4,7.6-17,13.1c-7.5,8.7-7.8,22.9-0.5,31.7c6.8,8.1,18.9,10.7,29.1,7.6S537,125,542,115.6c1.2-2.3,2.3-4.8,4.1-6.8 c3.3-3.6,8.5-4.9,12.5-7.6c3.8-2.6,6.6-6.4,8-10.9c1.6-5.7,0.6-11.8,1.7-17.7c1.2-6.9,5.1-13.3,4.7-20.2 C572.5,43.7,564.8,36.3,556.2,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M563.5,89.1c1.9,11.6-8.2,12-8.4,12.1c-3.2,1.5-9-2.1-10.6-6.2L515,3.5c-0.6-1.4,1.7-2.5,3.1-3.2 c0.5-0.2,1-0.3,1.5-0.3c3.6-0.4,7.8,2,9.9,5.1C540.5,21.2,561,74,563.5,89.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M521.3,240.4c2.3-4.5,4.3-19.1,5.6-23.4c4.3-14.9,13.8-71.5,10.9-80c-8.2-23.8-5.1-20.5-2.4-36.6 c2.7-16,8.3-31,13.7-33.4c17.3-7.7,27.3,3.8,33.2,24.5c4.7,16.5,9.3,70.7,7.7,93.2c1.9,16,2.9,32,2.8,48.1 c-12.3,5.9-27.8,5.5-41.4,9.2c-3.9,1.1-7.6,2.5-11.5,3.8c-3,1-6.3,1-9.2-0.2h0C527.3,244.5,524.2,242.7,521.3,240.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M564.7,83.9c-2.9,10.4,6.9,12.4,7.1,12.6c3,1.9,9-0.5,10.8-3.9l36.7-79.6c0.7-1.2-1.5-2.6-2.8-3.4 c-0.4-0.3-0.9-0.4-1.4-0.5c-3.5-1-7.7,0.6-10,3.1C593.1,25.1,568.5,70.3,564.7,83.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M562.9,60.5c0,0,16.2-5.7,17.6-21.9c1.9-21.7-20-32.6-32-25.5c-11,6.5-9.2,15.9-8,18.3S562.9,60.5,562.9,60.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M568.2,40l-17.4-1.7c-0.2,2.4-2.1,25.1-1.2,33.6c0.6,2.6,5,3.9,9.7,2.7c4.2-1,7.3-3.6,7.4-6l0,0 C566.2,63.5,567.4,48.4,568.2,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M566.9,43.3c-3.7,13.5-16.1,21.9-24.4,19.7c-8.3-2.3-9.2-14.3-5.6-27.8s12.3-18.6,20.5-16.3 S570.5,29.8,566.9,43.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M546.2,16.8c0,0,3,18.5,20,25.2c8.7,3.4,11.9-10.4,11.9-10.4l-8.4-13.4c0,0-7-5.8-12.4-5.3 C556.9,12.9,546.2,16.8,546.2,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M539.7,27.2c0,0,15.5-5.2,17.9-10.5c2.4-5.3-5.5-4.8-5.5-4.8C545.6,14.5,540.9,20.3,539.7,27.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M564.5,16c0,0-6.8-5.6-2-11.9c4.8-6.4,12.9-3.8,14.7,1.3c1.9,5.7-1,9.1-3.3,10.6 C570.9,17.7,567.4,17.6,564.5,16"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.246 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M496.9,143.1c-1.5,3.2-6.5,5.8-8.8,4.7s-1.7-3.9-0.2-7s4.7-5.3,7-4.2C497.2,137.7,498.4,140,496.9,143.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M487.3,37.1c-2.4-2.4-3.5-5.8-3-9.1c1.2-8.6,4.1-24.7,8.6-27.6c6.2-4,6.4,24-4.2,38.1L487.3,37.1L487.3,37.1z "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.318 7.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M529.8,23c-13.9,14.5-39.4,50.4-44.2,62.2c-4,9.8,2,12.1,2.2,12.2c2.5,2,8.5,0.9,10.7-2.3l39.2-66.5L529.8,23 L529.8,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M545.8,37.5c-3-1.6-5.1-4.5-5.6-7.8c-1.4-8.6-3.5-24.8,0-28.9c4.7-5.6,13.3,21,7.3,37.6L545.8,37.5 L545.8,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M541.3,32.6c5.7,19.3,24.4,59.2,32.2,69.2c6.5,8.3,11.5,4.2,11.7,4.1c3-1.2,5-7,3.2-10.4l-38.5-67L541.3,32.6 L541.3,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M533.1,402.2c0,0,12.8,1.5,12.1,4.4c-0.7,3-14.3,44.3-16.3,43.9c-6.8-1.5-0.6-37.1,1.3-40.2 S531.2,402,533.1,402.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M550.9,602.3c0,0-4.6,12.1-1.6,12.8c3,0.7,45.9,7.6,46.4,5.6c1.7-6.7-32.7-17.6-36.3-17.3 C555.9,603.7,551.5,600.6,550.9,602.3"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1668.2,124.3l-57.4,126.1h21.7l-38.5,84.5h25.2l-50.1,110h33.6L1540,582.3h128.2V124.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1668.2,124.3v457.9h128.2l-62.6-137.4h33.6l-50.1-110h25.2l-38.5-84.5h21.7L1668.2,124.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M1532.3,196l-50.7,111.2h19.2l-34,74.5h22.2l-44.2,97h29.6l-55.3,121.2h113.1V196z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1590.1,478.7h29.6l-44.2-97h22.2l-34-74.5h19.2L1532.3,196v403.9h113.1L1590.1,478.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1781.9,633.8c5,20.9,11.1,37.2,14.6,57.8c-7.3,5.7-17.2,14-24.6,19.8c-23.3-37.6-41.9-77.9-55.5-120 c-5.5-17.1-10.2-35.2-7.5-53c1-6.8,5.3-16.7,13.3-17.5c8.6-0.9,20.3,11,25,18.3C1762.3,563.1,1770.8,587.1,1781.9,633.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1837.7,513.1c2.1,55.2-9.1,109.7-22,163.6c-8.8,6.9-17.7,13.9-26.8,21c-7.6-34.5-12.4-69.6-14.2-104.9 c-1.9-35.4-4.2-64.7,15.7-99.6c5.2-9.1,16.1-19.4,26.5-17.6C1832.1,478.2,1837.1,497.6,1837.7,513.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1893.6,566.2c1.9,10.3-2.4,20.6-6.9,30.1c-7,14.7-28.8,53.5-38,67.2c-17,13.6-22.1,4.6-40.9,19.3 c12.6-41.1,28.8-84.6,55.2-117c6-7.3,15.5-15.1,23.8-10.6C1890.6,557.5,1892.8,561.9,1893.6,566.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLockup);
export default __webpack_public_path__ + "static/media/why-lockup.062f189a4d721ca4c74521ad49e48efb.svg";
export { ForwardRef as ReactComponent };